import React, { useState, useEffect } from 'react';
import './index.css';

const API_BASE = process.env.REACT_APP_API_URL;

const LineItemsGrid = ({
    rowData,
    changeOrder,
    job,
    estimateAccepted,
    selectLineItemsMode,
    selectedLineItems,
    onLineItemSelection,
    setFormData,
    discount,
    discount_description,
    permit_description,
    permit_total,
    handleDiscountInput,
    onToggleSelectLineItemsMode,
}) => {        
    const [gridData, setGridData] = useState([]);
    const [reArrange, setReArrange] = useState(false);
    const [isEditable, setIsEditable] = useState(changeOrder || !estimateAccepted);
    const [locked, setLocked] = useState(false);
    const [selectedEditableRow, setSelectedEditableRow] = useState(null);
    const [editingRowId, setEditingRowId] = useState(null);
    const [showDiscountSection, setShowDiscountSection] = useState(!!discount || !!discount_description);
    const [showOtherCostsSection, setShowOtherCostsSection] = useState(
        !!permit_description || parseFloat(permit_total) > 0
    );

    const updateGridData = (data) => {
        const sortedData = sortAndUpdateLineNumbers(data);
        setGridData(sortedData);
    };

    const handleFieldChange = (id, field, value) => {
        setGridData((prev) =>
            prev.map((item) => {
                if (item.id !== id) return item;
                const updated = { ...item, [field]: value };
                updated.total_price = calculateTotalPrice(updated);
                return updated;
            })
        );
    };

    const persistRow = (item) => {
        if (!item?.id) return;
        const url = API_BASE + `/api/joblineitems/${item.id}/`;
        fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body: JSON.stringify(item),
        }).catch((err) => console.error("Failed to save row", err));
    };

    const formatCurrency = (value) => {
        const num = parseFloat(value) || 0;
        return `$${num.toFixed(2)}`;
    };

    useEffect(() => {
        updateGridData(rowData);
        setSelectedEditableRow(null);
        if (!selectLineItemsMode) {
            setEditingRowId(null);
        }
        const newIsEditable = (changeOrder && !estimateAccepted) || selectLineItemsMode;
        const allowReorder = (!estimateAccepted || changeOrder) && selectLineItemsMode;
    
        // Only update if there's a change
        if (isEditable !== newIsEditable) {
            setIsEditable(newIsEditable);
        }
        if (reArrange !== allowReorder) {
            setReArrange(allowReorder);
        }
    
    }, [
        rowData,
        changeOrder,
        estimateAccepted,
        selectLineItemsMode,
        selectedLineItems,
        discount,
        discount_description,
        permit_description,
        permit_total,
    ]);
    

    const handleAddDiscount = () => {
        setShowDiscountSection(true);
    };

    const handleAddOtherCosts = () => {
        setShowOtherCostsSection(true);
    };

    const setEditingRow = (row) => {
        if (!canModifyRows || !row?.id) return;
        setEditingRowId(row.id);
        setSelectedEditableRow(row);
    };

    const handleDiscountTextChange = (e) => {
        const value = e.target.value;
        setFormData((prev) => ({
            ...prev,
            discount_description: value,
        }));
    };

    const handleDiscountAmountChange = (e) => {
        const parsed = parseFloat(e.target.value);
        if (isNaN(parsed)) return;
        handleDiscountInput(parsed);
        setFormData((prev) => ({
            ...prev,
            discount: parsed,
        }));
    };

    const handleOtherCostsTextChange = (e) => {
        const value = e.target.value;
        setFormData((prev) => ({
            ...prev,
            permit_description: value,
        }));
    };

    const handleOtherCostsAmountChange = (e) => {
        const parsed = parseFloat(e.target.value);
        if (isNaN(parsed)) return;
        setFormData((prev) => ({
            ...prev,
            permit_total: parsed,
        }));
    };

    const sortAndUpdateLineNumbers = (data) => {
        return data
            .filter(item => !item.isFooter)
            .sort((a, b) => a.line_item_number - b.line_item_number)
            .map((item, index) => ({ ...item, line_item_number: index + 1 }));
    };

    const calculateTotalPrice = (item) => {
        const laborPrice = parseFloat(item.labor_price) || 0;
        const materialsPrice = parseFloat(item.materials_price) || 0;
        const equipmentPrice = parseFloat(item.equipment_price) || 0;
        return laborPrice + materialsPrice + equipmentPrice;
    };

    const getSummary = () => {
        const totals = gridData.reduce(
            (acc, item) => ({
                labor: acc.labor + (parseFloat(item.labor_price) || 0),
                materials: acc.materials + (parseFloat(item.materials_price) || 0),
                equipment: acc.equipment + (parseFloat(item.equipment_price) || 0),
            }),
            { labor: 0, materials: 0, equipment: 0 }
        );

        const grandTotal = totals.labor + totals.materials + totals.equipment;

        const percent = (value) =>
            grandTotal > 0 ? `${((value / grandTotal) * 100).toFixed(2)}%` : "0.00%";

        return {
            totals,
            grandTotal,
            percents: {
                labor: percent(totals.labor),
                materials: percent(totals.materials),
                equipment: percent(totals.equipment),
                total: grandTotal > 0 ? "100.00%" : "0.00%",
            },
        };
    };

    const calculateSumsAndPercentages = (data) => {
        const totals = {
            labor_price: 0,
            materials_price: 0,
            equipment_price: 0,
            total_price: 0,
        };

        console.log(data);

        data.forEach(item => {
            totals.labor_price += parseFloat(item.labor_price) || 0;
            totals.materials_price += parseFloat(item.materials_price) || 0;
            totals.equipment_price += parseFloat(item.equipment_price) || 0;
            totals.total_price += calculateTotalPrice(item);
        });

        console.log(totals);

        const percentages = {
            labor_price: 0,
            materials_price: 0,
            equipment_price: 0,
            total_price: 0
        };

        console.log(totals.total_price);
        const grandTotal = totals.total_price;
        console.log(discount);
        console.log(grandTotal);
        if (grandTotal > 0) {
            percentages.labor_price = (totals.labor_price / grandTotal) * 100;
            percentages.materials_price = (totals.materials_price / grandTotal) * 100;
            percentages.equipment_price = (totals.equipment_price / grandTotal) * 100;
            percentages.total_price = (totals.total_price / grandTotal) * 100;
        }

        return { totals, percentages };
    };

    const handleRowClick = () => {};
    
    const onCellValueChanged = () => {};

    const onRowDragEnd = () => {};

    const addRow = (e) => {
        e.preventDefault();
    
        const newRow = {
            job: job,
            line_item_number: gridData.length + 1,
            description: '',
            labor_price: 0,
            materials_price: 0,
            equipment_price: 0,
            total_price: 0
        };
    
        const token = localStorage.getItem('access_token');
        const url = API_BASE + '/api/joblineitems/';
    
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(newRow)
        })
        .then(response => response.json())
        .then(data => {
            updateGridData([data, ...gridData]);
            setEditingRowId(data.id);
        })
        .catch(error => console.error('Add row failed:', newRow, error));
    };

    const removeLastRow = (e) => {
        e.preventDefault();
    
        const nonFooterData = gridData;
        const lastRow = nonFooterData[nonFooterData.length - 1];
        
        if (lastRow) {
            const token = localStorage.getItem('access_token');
            const url = API_BASE + `/api/joblineitems/${lastRow.id}/`;
    
            fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            })
            .then(response => {
                if (response.ok) {
                    const newData = nonFooterData.slice(0, -1);
                    updateGridData(newData);
                } else {
                    console.error('Failed to delete the last row:', lastRow);
                }
            })
            .catch(error => console.error('Delete row failed:', lastRow, error));
        }
    };

    const deleteSelectedRow = (e) => {
        e.preventDefault();
        if (!selectedEditableRow || selectedEditableRow.isFooter) return;

        const token = localStorage.getItem('access_token');
        const url = API_BASE + `/api/joblineitems/${selectedEditableRow.id}/`;

        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.ok) {
                const remaining = gridData.filter(item => item.id !== selectedEditableRow.id);
                setSelectedEditableRow(null);
                updateGridData(remaining);
            } else {
                console.error('Failed to delete the selected row:', selectedEditableRow);
            }
        })
        .catch(error => console.error('Delete selected row failed:', selectedEditableRow, error));
    };

    const refreshGrid = (e) => {
        e.preventDefault();
        updateGridData(rowData);
    };

    const handleSaveClick = () => {
        if (!editingRowId) return;
        const row = gridData.find((r) => r.id === editingRowId);
        if (row) {
            persistRow(row);
            setEditingRowId(null);
        }
    };

    const getRowClass = () => '';

    const handleScroll = (e, direction) => {};

    const handleToggleSelection = (e) => {
        e.preventDefault();
        if (onToggleSelectLineItemsMode) {
            onToggleSelectLineItemsMode();
        }
    };

    const canModifyRows = (!estimateAccepted || changeOrder) && selectLineItemsMode;

    return (
        <div className="ag-theme-alpine" style={{ height: 'auto', width: '100%' }}>
            <div className="line-item-toolbar">
                <button
                    type="button"
                    className="button toolbar-button span-2"
                    onClick={handleToggleSelection}
                >
                    {selectLineItemsMode
                        ? 'Disable Selection of Line Items'
                        : 'Enable Selection of Line Items'}
                </button>
                <button
                    type="button"
                    className="button toolbar-button span-2"
                    onClick={refreshGrid}
                >
                    Re-fresh
                </button>
                <button
                    type="button"
                    className={`button toolbar-button${!canModifyRows ? ' disabled' : ''}`}
                    onClick={(e) => addRow(e)}
                    disabled={!canModifyRows}
                >
                    Add
                </button>
                <button
                    type="button"
                    className={`button toolbar-button${!canModifyRows ? ' disabled' : ''}`}
                    onClick={(e) => removeLastRow(e)}
                    disabled={!canModifyRows}
                >
                    Remove Last
                </button>
                <button
                    type="button"
                    className={`button toolbar-button${(!canModifyRows || !selectedEditableRow) ? ' disabled' : ''}`}
                    onClick={(e) => deleteSelectedRow(e)}
                    disabled={!canModifyRows || !selectedEditableRow}
                >
                    Delete Line
                </button>
                <button
                    type="submit"
                    className="button toolbar-button"
                    onClick={handleSaveClick}
                >
                    Save
                </button>
            </div>

      <div className="invoice-table-wrapper">
                <table className="invoice-table">
                  <colgroup>
                    <col className="col-num" />
                    <col className="col-label" />
                    <col className="col-price" />
                    <col className="col-label" />
                    <col className="col-price" />
                    <col className="col-label" />
                    <col className="col-price" />
                    <col className="col-total" />
                  </colgroup>
          <thead>
            <tr className="header-top">
              <th className="header-number" rowSpan={2}>#</th>
              <th
                className="header-description"
                colSpan={6}
              >
                Description
              </th>
              <th className="header-total" rowSpan={2}>Total $</th>
            </tr>
            <tr className="header-sub">
              <th className="header-sub-cell header-label-cell">L</th>
              <th className="header-sub-cell">Labor $</th>
              <th className="header-sub-cell header-label-cell">M</th>
              <th className="header-sub-cell">Materials $</th>
              <th className="header-sub-cell header-label-cell">E</th>
              <th className="header-sub-cell">Equipment $</th>
            </tr>
          </thead>
          <tbody>
            {gridData.map((item, idx) => (
              <React.Fragment key={item.id || idx}>
                <tr
                  className={`line-primary${editingRowId === item.id && canModifyRows ? " line-editing" : ""}`}
                  onClick={() => setEditingRow(item)}
                >
                  <td rowSpan={2} className="cell-number">
                    {item.line_item_number}
                  </td>
                  <td
                    className="cell-description"
                    colSpan={6}
                  >
                    {editingRowId === item.id && canModifyRows ? (
                      <input
                        className="cell-input description-input"
                        value={item.description}
                        onChange={(e) => handleFieldChange(item.id, "description", e.target.value)}
                      />
                    ) : (
                      item.description
                    )}
                  </td>
                  <td rowSpan={2} className="cell-total">
                    {formatCurrency(item.total_price)}
                  </td>
                </tr>
                <tr className={`line-secondary${editingRowId === item.id && canModifyRows ? " line-editing" : ""}`}>
                  <td className="cell-label-only">L</td>
                  <td className="cell-price">
                    {editingRowId === item.id && canModifyRows ? (
                      <input
                        className="cell-input"
                        type="number"
                        value={item.labor_price}
                        onChange={(e) => handleFieldChange(item.id, "labor_price", e.target.value)}
                      />
                    ) : (
                      <span className="cell-value">
                        {formatCurrency(item.labor_price)}
                      </span>
                    )}
                  </td>
                  <td className="cell-label-only">M</td>
                  <td className="cell-price">
                    {editingRowId === item.id && canModifyRows ? (
                      <input
                        className="cell-input"
                        type="number"
                        value={item.materials_price}
                        onChange={(e) => handleFieldChange(item.id, "materials_price", e.target.value)}
                      />
                    ) : (
                      <span className="cell-value">
                        {formatCurrency(item.materials_price)}
                      </span>
                    )}
                  </td>
                  <td className="cell-label-only">E</td>
                  <td className="cell-price">
                    {editingRowId === item.id && canModifyRows ? (
                      <input
                        className="cell-input"
                        type="number"
                        value={item.equipment_price}
                        onChange={(e) => handleFieldChange(item.id, "equipment_price", e.target.value)}
                      />
                    ) : (
                      <span className="cell-value">
                        {formatCurrency(item.equipment_price)}
                      </span>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ))}
            </tbody>
        </table>
      </div>

            <div className="summary-table-wrapper">
                {(() => {
                    const summary = getSummary();
                    const { totals, grandTotal, percents } = summary;
                    return (
                        <table className="summary-table">
                            <colgroup>
                                <col className="col-num" />
                                <col className="col-label" />
                                <col className="col-price" />
                                <col className="col-label" />
                                <col className="col-price" />
                                <col className="col-label" />
                                <col className="col-price" />
                                <col className="col-total" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td className="summary-label">ST</td>
                                    <td className="summary-label">L</td>
                                    <td className="summary-value">{formatCurrency(totals.labor)}</td>
                                    <td className="summary-label">M</td>
                                    <td className="summary-value">{formatCurrency(totals.materials)}</td>
                                    <td className="summary-label">E</td>
                                    <td className="summary-value">{formatCurrency(totals.equipment)}</td>
                                    <td className="summary-total">{formatCurrency(grandTotal)}</td>
                                </tr>
                                <tr>
                                    <td className="summary-label">%</td>
                                    <td className="summary-label">L</td>
                                    <td className="summary-value">{percents.labor}</td>
                                    <td className="summary-label">M</td>
                                    <td className="summary-value">{percents.materials}</td>
                                    <td className="summary-label">E</td>
                                    <td className="summary-value">{percents.equipment}</td>
                                    <td className="summary-total">{percents.total}</td>
                                </tr>
                            </tbody>
                        </table>
                    );
                })()}
            </div>

            <div className="line-item-footer-actions">
                <button className="button toolbar-button" onClick={handleAddOtherCosts}>
                    Add Other Costs
                </button>
            </div>

            {showOtherCostsSection && (
                <div className="discount-table-wrapper">
                    <table className="discount-table">
                        <tbody>
                            <tr>
                                <td className="discount-label">OTHER COSTS</td>
                                <td className="discount-input-cell">
                                    <textarea
                                        className="discount-textarea"
                                        value={permit_description || ""}
                                        onChange={handleOtherCostsTextChange}
                                        placeholder="Enter other cost reason/description"
                                    />
                                </td>
                                <td className="discount-amount-cell">
                                    <input
                                        type="number"
                                        className="discount-amount-input"
                                        value={permit_total ?? 0}
                                        onChange={handleOtherCostsAmountChange}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div className="line-item-footer-actions">
                <button className="button toolbar-button" onClick={handleAddDiscount}>
                    Add Discount
                </button>
            </div>

            {showDiscountSection && (
                <div className="discount-table-wrapper">
                    <table className="discount-table">
                        <tbody>
                            <tr>
                                <td className="discount-label">DISCOUNT</td>
                                <td className="discount-input-cell">
                                    <textarea
                                        className="discount-textarea"
                                        value={discount_description || ""}
                                        onChange={handleDiscountTextChange}
                                        placeholder="Enter discount reason/description"
                                    />
                                </td>
                                <td className="discount-amount-cell">
                                    <input
                                        type="number"
                                        className="discount-amount-input"
                                        value={discount ?? 0}
                                        onChange={handleDiscountAmountChange}
                                    />
                                    <div className="discount-amount-display">
                                        ({formatCurrency(discount || 0)})
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {(() => {
                const summary = getSummary();
                const depositRate = 0.5;
                const otherCosts = parseFloat(permit_total) || 0;
                const totalJobCost = summary.grandTotal + otherCosts - (parseFloat(discount) || 0);
                const depositDue = totalJobCost * depositRate;
                return (
                    <div className="deposit-summary">
                        <div className="deposit-row">
                            <span className="deposit-label">TOTAL JOB COST</span>
                            <span className="deposit-value">{formatCurrency(totalJobCost)}</span>
                        </div>
                        <div className="deposit-row">
                            <span className="deposit-label">DEPOSIT</span>
                            <span className="deposit-value">{(depositRate * 100).toFixed(1)}%</span>
                        </div>
                        <div className="deposit-row">
                            <span className="deposit-label">TOTAL DEPOSIT DUE</span>
                            <span className="deposit-value">{formatCurrency(depositDue)}</span>
                        </div>
                    </div>
                );
            })()}

            <div className="line-item-footer-actions">
                <button className="button toolbar-button" onClick={handleSaveClick}>
                    Save
                </button>
            </div>

        </div>
    );
};

export default LineItemsGrid;
